import React from 'react';
import WaterGlassLoader from './WaterGlassLoader';

export default function LoadingScreen() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '70vh', gap: 16 }}>
      <WaterGlassLoader color="#1A6DB5" />
    </div>
  );
}
